/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Row, Col, Button }  from 'reactstrap'

import ConfirmationModal from '../widgets/ConfirmationModal'
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { JsonView } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

import {AppContext} from '../AppContext';

class SupportInfo extends React.Component
{
  clearLocalStorage(event)
  {
    event.preventDefault();
    this.setState({confirmationModalIsOpen: true});
  }

  closeConfirmationModal(confirmed)
  {
    this.setState({confirmationModalIsOpen: false});    
    if (confirmed)
    {
      this.context.appLocalStorage.clear();
    } 
  }

  componentDidMount()
  {
    this.getSupportInfo();
  }
  
  collapseAllNodes()
  {
    return false;
  }

  constructor(props)
  {
    super();

    this.state =
    {
      supportInfo: null,
      confirmationModalIsOpen: false
    }

    this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
    this.clearLocalStorage = this.clearLocalStorage.bind(this);
  }

  async getSupportInfo()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getSupportInfo');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting support info');
      let supportInfo = 
      {
        profileName: result.jsonData.serverInfo.profileName,
        gitTag: result.jsonData.serverInfo.gitTag,
        gitBranch: result.jsonData.serverInfo.gitBranch,
        pluginServers: result.jsonData.pluginServers,
        gateways: result.jsonData.gateways,
        streamingServers: result.jsonData.streamingServers,
        dbTwigListener: result.jsonData.dbTwigListener,
        databaseVersion: result.jsonData.databaseVersion,
        databaseClientVersion: result.jsonData.databaseClientVersion,
        webAppVersion: window.webAppVersion,
        buildDate: window.buildDate,
        extensions: result.jsonData.extensions
      }
      this.setState({ supportInfo: supportInfo })
  }

  render()
  {
    document.title = this.context.websiteProfile.profileName + ': Support Info';
    
    let modalText = 'Are you sure you want to clear the web-application\'s local storage?  Doing so will cause the web-application to lose your settings but it may help with any anomalies you are experiencing.'

    return(
      <div>
        <ConfirmationModal modalIsOpen={this.state.confirmationModalIsOpen} closeModal={this.closeConfirmationModal} 
          modalText={modalText}/>
        <Row>
          <Col><h6>Support HelpDesk Email: <a href="mailto:support@asteriondb.com">support@asteriondb.com</a></h6></Col>
        </Row>            
        <Row>
          <Col><h6>Please include the following information in your email correspondence:</h6></Col>
        </Row>
        { this.state.supportInfo != null &&
        <span>
          <Row>
            <Col sm="3">Profile Name</Col><Col>{this.state.supportInfo.profileName}</Col>
          </Row>
          <Row>
            <Col sm="3">Schema Version</Col><Col>{this.state.supportInfo.gitTag}-{this.state.supportInfo.gitBranch}</Col>
          </Row>
          <Row>
            <Col sm="3">dbTwig Listener Version</Col><Col>{this.state.supportInfo.dbTwigListener}</Col>
          </Row>
          <Row>
            <Col sm="3">SecureObjects Server Web-App Version</Col><Col>{this.state.supportInfo.webAppVersion}</Col>
          </Row>
          <Row>
            <Col sm="3">SecureObjects Server Web-App Build Date</Col><Col>{this.state.supportInfo.buildDate}</Col>
          </Row>
          <Row>
            <Col sm="3">Database Version</Col><Col>{this.state.supportInfo.databaseVersion}</Col>
          </Row>
          <Row>
            <Col sm="3">Database Client Version</Col><Col>{this.state.supportInfo.databaseClientVersion}</Col>
          </Row>
          <Row>
            <Col sm="3">Plugin Servers</Col><Col sm='4'><JsonView shouldInitiallyExpand={this.collapseAllNodes} data={this.state.supportInfo.pluginServers}/></Col>
          </Row>
          <Row>
            <Col sm="3">Streaming Servers</Col><Col sm='4'><JsonView shouldInitiallyExpand={this.collapseAllNodes} data={this.state.supportInfo.streamingServers}/></Col>
          </Row>
          <Row>
            <Col sm="3">File System Gateways</Col><Col sm='4'><JsonView shouldInitiallyExpand={this.collapseAllNodes} data={this.state.supportInfo.gateways}/></Col>
          </Row>
          <Row>
            <Col sm="3">Extensions</Col><Col sm='4'><JsonView shouldInitiallyExpand={this.collapseAllNodes} data={this.state.supportInfo.extensions}/></Col>
          </Row>
        </span>
      }
        <Row>
          <Col>Icons made by <a href="https://www.flaticon.com/authors/smashicons" title="Smashicons">Smashicons</a> from <a href="https://www.flaticon.com/"             title="Flaticon">www.flaticon.com</a></Col>
        </Row>
        <Row>
          <Col sm='2'>        
            <CopyToClipboard text={JSON.stringify(this.state.supportInfo, null, '\t')} 
              onCopy={() => this.context.postNotification('info', 'Support info copied to paste buffer.')}>
              <Button>Copy Support Info</Button>
            </CopyToClipboard>
          </Col>
          <Col><Button onClick={this.clearLocalStorage}>Clear Local Storage</Button></Col>
        </Row>
      </div>
    )
  }
}

SupportInfo.contextType = AppContext;

export default SupportInfo